export default __webpack_public_path__ + "static/media/oak.texture.fd7c58fc.webp";